import Api from '../../../utils/api.js'
export const SET_CART = 'SET_CART'

export function setCart (cart) {
  const result = {
    type: SET_CART,
    payload: cart
  }
  return result
}

export function getCart () {
  return dispatch => {
    return Api.getCart().then(payload => {
      dispatch(setCart(payload))
    })
  }
}

export function updateInCart (item, quantity, toRemove = null, qtyToRemove = 0) {
  return dispatch => {
    return Api.updateInCart(item, quantity, toRemove, qtyToRemove).then(payload => {
      dispatch(getCart())
    })
  }
}
